package me.repeater64.advancedmpkeditor.gui.screens

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ExperimentalMaterial3ExpressiveApi
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import me.repeater64.advancedmpkeditor.backend.data_object.saved_hotbar.SavedHotbars
import me.repeater64.advancedmpkeditor.backend.presets_examples.DefaultHotbars
import me.repeater64.advancedmpkeditor.gui.component.verticalColumnScrollbar

@OptIn(ExperimentalMaterial3ExpressiveApi::class)
@Composable
fun HomeScreen(
    onOpenEditor: (SavedHotbars) -> Unit,
    onOpenImport: () -> Unit
) {

    val scrollState = rememberScrollState()
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(20.dp),
        modifier = Modifier
            .padding(24.dp).verticalColumnScrollbar(scrollState).verticalScroll(scrollState)
    ) {
        Text(
            "Welcome to Advanced MPK Editor",
            style = MaterialTheme.typography.displayLargeEmphasized,
            color = MaterialTheme.colorScheme.primary
        )

        Text(
            "Choose an option to get started",
            style = MaterialTheme.typography.headlineLarge,
            color = MaterialTheme.colorScheme.secondary
        )

        Spacer(Modifier.height(20.dp))

        HomeScreenMenuButton("Start Editing Example Template", {onOpenEditor(DefaultHotbars.exampleTemplate)})

        HomeScreenMenuButton("Start Editing Blank Template", {onOpenEditor(DefaultHotbars.blankTemplate)})

        HomeScreenMenuButton("Import From hotbar.nbt", {onOpenImport()})
    }
}

@Composable
fun HomeScreenMenuButton(text: String, onClick: () -> Unit, content: @Composable ColumnScope.() -> Unit = {}) {
    OutlinedButton(
        onClick = onClick,
        modifier = Modifier.width(600.dp).height(90.dp),
        border = BorderStroke(3.dp, MaterialTheme.colorScheme.primary)
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(text, style = MaterialTheme.typography.headlineMedium, color = MaterialTheme.colorScheme.primary)
            content()
        }
    }
}